import { combineReducers } from "@reduxjs/toolkit";
import diningReducer, { initialState as diningInitialState } from "./diningReducer";

const rootReducer = combineReducers({
  dining: diningReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const initialState: RootState = {
  dining: diningInitialState,
};

export default rootReducer;
